// Branch (Sucursal) mapping constants
// Based on switch statement from pse-eccargo-web/Interno/PagosPSE.aspx.cs:585

export const BRANCH_MAPPING = {
  1: {
    name: "Bogotá",
    code: "BOG",
    filePrefix: "FV"
  },
  2: {
    name: "Medellín",
    code: "MDE",
    filePrefix: "VR"
  },
  5: {
    name: "Barranquilla",
    code: "BAQ",
    filePrefix: "BQ"
  },
  9: {
    name: "Bucaramanga",
    code: "BUC",
    filePrefix: "BGA"
  },
  10: {
    name: "Cali",
    code: "CLI",
    filePrefix: "CLO"
  }
};

// Currency constants
export const CURRENCIES = {
  COP: {
    code: 'COP',
    symbol: '$',
    name: 'Peso Colombiano',
    decimals: 0
  },
  USD: {
    code: 'USD',
    symbol: 'US$',
    name: 'Dólar Americano',
    decimals: 2
  },
  EUR: {
    code: 'EUR',
    symbol: '€',
    name: 'Euro',
    decimals: 2
  }
};

// Timezone constants
export const TIMEZONE = {
  COLOMBIA: 'America/Bogota', // GMT-5
  UTC: 'UTC'
};

// Helper functions
export const getBranchName = (sucursalId) => {
  return BRANCH_MAPPING[sucursalId]?.name || `Sucursal ${sucursalId}`;
};

export const getBranchCode = (sucursalId) => {
  return BRANCH_MAPPING[sucursalId]?.code || sucursalId;
};

export const formatCurrency = (amount, currency = 'COP') => {
  const currencyInfo = CURRENCIES[currency];
  if (!currencyInfo) return amount;

  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: currencyInfo.decimals,
    maximumFractionDigits: currencyInfo.decimals
  }).format(amount);
};

export const formatDateColombia = (date) => {
  if (!date) return '';

  return new Intl.DateTimeFormat('es-CO', {
    timeZone: TIMEZONE.COLOMBIA,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }).format(new Date(date));
};